<template>
	<div class="pull-dialog-body">
		<div class="pull-container">
			<div class="middle-part">
				<div class="title">
				拉取店铺
				</div>
				<div class="main-part">
					<div class="select-part">
						<span>店铺编号：</span>
						<el-input v-model="shop_no" class="filter-input" size='mini'></el-input>

						<el-button type="primary" size='small' class="fx-btn" plain @click="search(1)">查询</el-button>
						<el-button type="primary" size='small' class="fx-btn" plain @click="search(0)">刷新</el-button>
					</div>

					<div class="main-table">
						<div class="main-table-box">
							<el-table
								class="grid-content"
								:data="tableData"
								border
								size='mini'
								stripe
								:height="tableHeight">
								<el-table-column label="选择" width='50' align="center">
									<template slot-scope="scope">
										<!-- <el-checkbox v-model="scope.row.status" @change="selectChange(scope.row)" ></el-checkbox> -->
										<el-radio v-model="radioCode" @change='radioChange(scope.row)' :label='scope.row.shop_id'></el-radio>
									</template>
								</el-table-column>
								<el-table-column
									prop="shop_no"
									label="店铺名称"
									align="center"
									min-width="180">
								</el-table-column>
								<el-table-column
									prop="shop_name"
									label="店铺名称"
									align="center"
									min-width="180">
								</el-table-column>
							</el-table>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="btn-box">
			<el-button class="btn" plain type="primary" @click="close">取消</el-button>
			<el-button class="btn" plain type="primary" @click="save">保 存</el-button>
		</div>
		<span @click="close" class="close"><i class="el-icon-close"/></span>
	</div>
</template>
<script>
export default {
	name: 'pullDialog',
	props: {
		pullData: Array
	},
	data () {
		return {
			rowData: null,
			radioCode: '',
			firstCldPull: null,
			shopTableData: [],
			tableHeight: '100%',
			shop_no: '',
			tableData: [],
			selectedArr: [],
			selectedArr1: []
		}
	},
	created () {
		this.tableData = this.pullData
	},
	methods: {
		radioChange (data) {
			this.radioCode = data.shop_id
			this.rowData = data
		},
		search (data) {
			if (data === 0) {
				this.shop_no = ''
			}
			let params = {
				shop_no: this.shop_no
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/match/getWDTShopInfo`,
				data: params
			}).then(res => {
				if (res.result) {
					this.radioCode = ''
					this.tableData = res.data
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		close () {
			this.$emit('update:visible', false)
		},
		save () {
			if (this.radioCode === '') {
				this.$message.error('请选择店铺')
				return false
			}
			var data = this.rowData

			var row = {
				name: data.shop_name,
				memo: data.remark,
				matchid: data.shop_id,
				mdname: data.shop_name,
				mdcode: data.shop_no,
				tel: data.telno,
				linkman: data.contact,
				province: data.province,
				address: data.address,
				city: data.city
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/match/saveWDTShopInfo`,
				data: row
			}).then(res => {
				if (res.result) {
					this.$message.success('保存成功')
					this.$emit('update:visible', false)
					this.$emit('tableReload', true)
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		cancel () {
			this.dialogVisible = false
		}
	}
}
</script>

<style lang="stylus" scoped>
.pull-dialog-body {
	display flex
	flex: 1
	flex-direction column
	height: 450px;
	padding-top: 10px;
	.pull-container {
		display flex
		flex: 1
		.middle-part {
			width :99%
			.title {
				width :90%
				text-align left
				border-left 5px solid var(--fx-primary-color)
				padding-left 10px
				line-height 28px;
				height: 28px;
				font-size 18px;
				margin-bottom 20px;
				span{
					color :#CBCBCB
					margin-left: 20px;
				}
			}
			display flex;
			height: 100%;
			flex: 1
			flex-direction column
			.main-part {
				display flex
				flex-direction column
				flex: 1
				height:350px;
				padding-top: 10px;
				border-top: 1px solid #efefef
				.select-part {
					display flex
					width: 100%
					height: 32px;
					line-height 32px;
					margin-bottom 10px;
					span {
						margin-right: 10px
					}
					.filter-input {
						width :150px
						margin-right: 20px;
					}
				}
				.fx-big-btn {
					margin 0 0 10px 0
				}
				.main-table {
					width :100%
					display flex
					flex: 1
					height: 100%;
					flex-direction: column
					padding-bottom 10px;
					.main-table-box {
						height:300px;
						padding-bottom 10px
						overflow-y: auto;
					}
				}
			}
		}
	}
	.btn-box {
		height: 40px;
		.el-button {
			width: 200px;
		}
	}
	.el-radio >>> .el-radio__label{
		display :none !important;
	}
	.close {
		position absolute
		right: 20px;
		top: 20px;
		cursor pointer
		width: 20px;
		height: 20px;
		border-radius: 50%;
		background-color: red;
		line-height: 21px;
		font-weight: bold;
		.el-icon-close{
			color:#fff
		}
	}
}
</style>
<style lang="stylus">

</style>
